import { ReactNode } from 'react';

import { RealObject } from '@tb-core/types';

export type ListItem = <T>(
    props: T & ListItemProps & any,
    i: number
) => ReactNode;

export interface ListItemProps {
    index: number;
}

interface ListProps {
    className?: string;
    item: ListItem;
    itemProps: RealObject[];
}

const ItemList = ({ className, item, itemProps = [] }: ListProps) => (
    <>{itemProps.map((props, i) => item({ className, ...props }, i))}</>
);

export default ItemList;
